import http from '@/utils/http'

/**
 * 用户登录
*/
export function login(data) {
    return http({
        method: 'post',
        url: '/sysAdmin/login',
        data
    })
}

/**
 * 用户登出
*/
export function logout() {
    return http({
        method: 'post',
        url: '/sysAdmin/logout'
    })
}

/**
 * 修改密码
*/
export function modifyPwd(data) {
    return http({
        method: 'post',
        url: '/sysAdmin/password/update',
        data
    })
}
